import permissionsServices from "../../../services/permission.service";

import {
  
  LIST_PERMISSION_ONE_USER_SUCCESS,
  LIST_PERMISSION_ONE_USER__FAIL
} from "./type";


export const getPermissionsByuser = () => (dispatch) => {
  return permissionsServices.permissionsByuser().then(
    (response) => {
      dispatch({
        type:  LIST_PERMISSION_ONE_USER_SUCCESS,
        payload: response.data,
      });
     
      return Promise.resolve();
    },
    () => {
     
      dispatch({
        type: LIST_PERMISSION_ONE_USER__FAIL,
      });

     
      return Promise.reject();
    }
  );
};